import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, MaskLine } from "@/components/Reveal";
import { IMG } from "@/data/site";

const POINTS = [
  "Professionelle Produktion",
  "Kreatives Storytelling",
  "Moderne Technik & Equipment",
  "Strategische Werbung",
  "End-to-End Produktion",
  "Persönliche Betreuung",
];

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section id="about" data-testid="about" className="relative py-32 sm:py-44 border-t border-white/5">
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-6 lg:sticky lg:top-28">
          <Reveal><p className="label mb-8">Über das Studio</p></Reveal>
          <h2 className="font-serif font-light text-4xl sm:text-6xl lg:text-7xl tracking-tight uppercase leading-[0.98]">
            <MaskLine>Ein Studio</MaskLine>
            <MaskLine delay={0.08}>aus Hamburg —</MaskLine>
            <MaskLine delay={0.16} className="text-[#d4c4a8] italic">von Anfang bis Ende.</MaskLine>
          </h2>
          <Reveal delay={0.15}>
            <p className="mt-10 font-body text-lg text-[#a1a1aa] leading-relaxed max-w-xl">
              Gold Media Studio ist ein kreatives Produktions- und Werbestudio in Hamburg. Wir verbinden
              professionelle Produktion, kreatives Storytelling und moderne Technik mit strategischer
              Werbung — von der Konzeption bis zur finalen Auslieferung. Ein Partner, persönliche
              Beziehungen, ein durchgängiger Prozess.
            </p>
          </Reveal>

          <div className="mt-10 grid grid-cols-2 gap-x-8 gap-y-4">
            {POINTS.map((p, i) => (
              <Reveal key={p} delay={0.1 + i * 0.05}>
                <div className="flex items-start gap-3 border-t border-white/5 pt-4">
                  <span className="text-[#d4c4a8] text-xs mt-1">✦</span>
                  <span className="font-body text-sm text-[#fafafa]">{p}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="lg:col-span-6 grid gap-6">
          <div className="img-zoom overflow-hidden border border-white/10 aspect-[4/5]">
            <motion.img style={{ y, scale: 1.15 }} src={IMG.crewSet} alt="Gold Media Studio Team Hamburg" loading="lazy" className="w-full h-full object-cover" />
          </div>
          <div className="grid grid-cols-2 gap-6">
            <div className="img-zoom overflow-hidden border border-white/10 aspect-square">
              <img src={IMG.studioSet} alt="Studio Setup Hamburg" loading="lazy" className="w-full h-full object-cover" />
            </div>
            <div className="border border-white/10 aspect-square flex flex-col justify-center p-6 bg-[#111]">
              <span className="font-serif text-5xl text-[#d4c4a8]">01</span>
              <p className="mt-3 font-display uppercase tracking-[0.15em] text-xs text-[#a1a1aa] leading-relaxed">
                Ein Partner vom Konzept bis zur finalen Auslieferung
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
